import ScrollReveal from "../../../components/feature/ScrollReveal";
import { sceneData } from "../../../mocks/giftData";

export default function SceneSection() {
  return (
    <section className="py-20 md:py-28 bg-airdoa-cream">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-12 md:mb-14">
              <p className="section-label mb-2">{sceneData.label}</p>
              <h2 className="section-title">{sceneData.title}</h2>
              <p className="section-subtitle max-w-2xl mx-auto">
                {sceneData.description}
              </p>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {sceneData.scenes.map((scene, idx) => (
              <ScrollReveal key={scene.title} direction="up" delay={idx * 80}>
                <div className="bg-white rounded-lg p-6 md:p-7 h-full border border-airdoa-gray-light/30">
                  <div className="w-10 h-10 flex items-center justify-center text-airdoa-gold mb-4">
                    <i className={`${scene.icon} text-2xl`} />
                  </div>
                  <h3 className="text-base font-serif font-semibold text-airdoa-navy mb-2">
                    {scene.title}
                  </h3>
                  <p className="text-sm text-airdoa-gray leading-relaxed">
                    {scene.desc}
                  </p>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}